import * as React from 'react';

import { ScreenReaderOnly } from '../ScreenReaderOnly';

import * as styles from './styles.css';

interface IPageProps {
  children: React.ReactNode;
  asideContent: React.ReactNode;
}

export const Page: React.FC<React.PropsWithChildren<IPageProps>> = ({ children, asideContent }) => {
  return (
    <>
      <main className={styles['container']}>
        <ScreenReaderOnly>
          <h1>Циан.Сделка - электронная сделка купли продажи недвижимости</h1>
        </ScreenReaderOnly>
        {children}
      </main>
      <aside>{asideContent}</aside>
    </>
  );
};
